import { gql } from '@api/gql';

export const GET_TASK_COUNT = gql(/* GraphQL */`
  query GetTaskCount($searchBy: SearchByArgs) {
    getTaskCount(searchBy: $searchBy)
  }
`);

export const GET_TASK_STATISTICS = gql(/* GraphQL */`
  query GetTaskStatistics($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getTaskStatistics(searchBy: $searchBy, options: $options) {
      total
      new_tasks
      open_tasks
      cancelled_tasks
      completed_tasks
      completion_percentage
    }
  }

`);

export const GET_TASK = gql(/* GraphQL */`
  query GetTask($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getTask(searchBy: $searchBy, options: $options) {
      ...TaskCoreFragment
      requested_period {
        __typename
        start
        end
      }
      patient {
        __typename
        patient_id
        user {
          ...UserCoreFragmentAlt
        }
      }
      steps {
        ...TaskStepCoreFragment
        focus {
          ...ResourceReferenceCoreFragment
          identifier {
            ...IdentifierCoreFragment
          }
        }
      }
      assignee {
        ... on StaffAssignments {
          ...PractitionerAssignmentCoreFragment
        }
      }
      based_on {
        ...ResourceReferenceCoreFragment
        identifier {
          ...IdentifierCoreFragment
        }
      }
      requested_period {
        __typename
        period_id
        start
        end
      }
    }
  }
`);

export const GET_ALL_TASKS = gql(/* GraphQL */`
  query GetAllTasks($searchBy: SearchByArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getAllTasks(searchBy: $searchBy, sort: $sort, options: $options) {
      ...TaskCoreFragment
      requested_period {
        __typename
        start
        end
      }
      patient {
        __typename
        patient_id
        user {
          ...UserCoreFragmentAlt
          demographics {
            __typename
            cynergy_id
            full_name
          }
        }
      }
      assignee {
        ... on StaffAssignments {
          ...PractitionerAssignmentCoreFragment
          employee {
            ...StaffCoreFragment

            user {
              ...UserCoreFragmentAlt
              demographics {
                __typename
                cynergy_id
                full_name
              }
            }
          }
        }
      }
      based_on {
        ...ResourceReferenceCoreFragment
        identifier {
          ...IdentifierCoreFragment
        }
      }
      requested_period {
        __typename
        period_id
        start
        end
      }
    }
  }
`);

export const GET_PAGINATED_TASKS = gql(/* GraphQL */`
  query GetPaginatedTasks($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getPaginatedTasks(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      count
      currentPage
      totalPages
      rows {
        ...TaskCoreFragment
        requested_period {
          __typename
          start
          end
        }
        patient {
          __typename
          patient_id
          user {
            ...UserCoreFragmentAlt
            demographics {
              ...DemographicsCoreFragmentAlt
            }
          }
        }
        assignee {
          ... on StaffAssignments {
            ...PractitionerAssignmentCoreFragment
            employee {
              staff_id
              user {
                user_id
                demographics {
                  cynergy_id
                  full_name
                }
              }
            }
          }
        }
        based_on {
          ...ResourceReferenceCoreFragment
          identifier {
            ...IdentifierCoreFragment
          }
        }
        requested_period {
          __typename
          period_id
          start
          end
        }
      }
    }
  }
`);

